import React from "react";
import GalleryPage from "../components/gallery/gallery";
import GalFooter from "../components/gallery/gallery-footer";
function Gallery() {
  return (
    <>
      <GalleryPage />
      <GalFooter />
    </>
  );
}

export default Gallery;
